<template>
  <div>
    <div v-if="type == `normal`" class="savedCard" :style="{backgroundColor: color}" @click.stop="toDetail">
      <div class="savedCard__info">
        <h2 class="savedCard__info__title large-font">{{saved.title}}</h2>
        <h2 class="savedCard__info__subtitle large-font">{{saved.subtitle}}</h2>
      </div>
      <div class="savedCard__action" @click.stop>
        <adx-menu-expansion v-if="saved.is_default" :lists="listsDefault" @selected="selected" :isWhite="true" />
        <adx-menu-expansion v-else :lists="lists" @selected="selected" :isWhite="true" />
      </div>
      <span class="savedCard__item small-font">{{saved.item}} items</span>
    </div>
    <div v-else-if="type == `long`" class="savedCardLong" :style="{backgroundColor: color}" @click.stop="toDetail">
      <div class="savedCardLong__info">
        <h2 class="savedCardLong__info__title large-font">{{saved.title}}</h2>
        <span class="savedCardLong__info__created">{{saved.created}} • {{saved.item}} items</span>
      </div>
      <div class="savedCardLong__action" @click.stop>
        <adx-menu-expansion v-if="saved.is_default" :lists="listsDefault" @selected="selected" :isWhite="true" />
        <adx-menu-expansion v-else :lists="lists" @selected="selected" :isWhite="true" />
      </div>
    </div>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-saved-card',
  props: {
    color: { required: true },
    saved: { required: true },
    items: { required: false, type: Array, default: () => [] },
    addtionalItems: { required: false, type: Array, default: () => [] },
    type: {
      required: false,
      default: "normal"
    }
  },
  components: {
    'adx-menu-expansion': MenuExpansion
  },
  data() {
    return {
      lists: [
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "campaign",
          "items": this.items
        },
        {
          "id": 2,
          "name": "Rename",
          "value": "rename"
        },
        {
          "id": 3,
          "name": "Duplicate",
          "value": "duplicate"
        },
        {
          "id": 4,
          "name": "Delete Folder",
          "value": "delete"
        }
      ],
      listsDefault: [
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "campaign",
          "items": this.items
        },
        {
          "id": 2,
          "name": "Duplicate",
          "value": "duplicate"
        },
      ],
    }
  },
  computed: {
    ...mapGetters ({
      isSuperuser: 'isSuperuser'
    }),
  },
  watch: {
    addtionalItems() {
      this.$nextTick(function () {
        this.lists[0] = ({
          id: 0,
          name: "Add to collection",
          value: "collection",
          items: this.addtionalItems
        })
        this.listsDefault[0] = ({
          id: 0,
          name: "Add to collection",
          value: "collection",
          items: this.addtionalItems
        })
      })
    }
  },
  mounted() {
    if (this.isSuperuser) {
      this.lists.unshift({
        id: 0,
        name: "Add to collection",
        value: "collection",
        items: this.addtionalItems
      })
      this.listsDefault.unshift({
        id: 0,
        name: "Add to collection",
        value: "collection",
        items: this.addtionalItems
      })
    }
  },
  methods: {
    selected(item){
      this.$emit('setSaved', this.saved)
      this.$emit('selected', item)
    },
    toDetail() {
      this.$router.push({ name: 'savedlist', params: { id: this.saved.id }})
    },
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>